import { render } from "./mouse.vue?vue&type=template&id=468ed654"
import script from "./mouse.vue?vue&type=script&lang=js"
export * from "./mouse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EDZ\\WebstormProjects\\one-nav-simple-theme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__